import { type FunctionComponent, useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  filtersDelivery,
  setFiltersDelivery,
  setFilterV
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";

interface DateChoosingProps {
  onClose?: () => void;
}

const DateChoosing: FunctionComponent<DateChoosingProps> = ({ onClose }) => {
  const [selectedDate, setSelectedDate] = useState<number | null>(null);

  useEffect(() => {
    const currentFilters = filtersDelivery();
    if (currentFilters?.creationDate) {
      setSelectedDate(currentFilters.creationDate);
    }
  }, []);

  const handleAccept = (newValue: dayjs.Dayjs | null) => {
    if (newValue) {
      setSelectedDate(newValue.unix());
      const currentFilters = filtersDelivery();
      currentFilters.creationDate = newValue.unix();
      setFiltersDelivery(currentFilters);
      console.log('currentFilters ', currentFilters);
      setFilterV(p => p + 1)
    }
    onClose?.()
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="w-[400px] h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
        <div className="flex flex-1 px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
          <div className="flex-1 font-bold text-[16px] text-[#0051c1]">
            Search Order Creation Time
          </div>
          <img
            src="/icon-close-popup-icon--grey@2x.png"
            className="w-[22px] h-[22px]"
            alt=""
            onClick={onClose}
          />
        </div>
        <div className="flex flex-col gap-2 p-3">
          <DatePicker
            label=""
            value={selectedDate ? dayjs.unix(selectedDate) : null}
            onAccept={handleAccept}
          />
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default DateChoosing;